import type { TableRowDefinition } from "$components/table";
import SupplyLevelChip from "$routes/_lib/inventory/supply-level-chip";
import { styled } from "@material-ui/core";

const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "center",
  alignItems: "baseline",
  gap: theme.spacing(1),
}));

const Copy = styled("p")({
  padding: 0,
  margin: 0,
});

interface Props {
  copy: string;
  data: TableRowDefinition;
}

export default function ItemNameWithSupplyChip({ copy, data }: Props) {
  return (
    <Wrapper data-testid="stock-item">
      <Copy id={`item-name-${data.id}`} data-testid="stock-item-copy">
        {copy}
      </Copy>
      {data.meta && (
        <SupplyLevelChip
          supplyLevel={data.meta.supplyLevel}
          quantity={data.meta.facilityQuantity}
          data-testid="stock-item-chip"
        />
      )}
    </Wrapper>
  );
}
